export default "/images/nist_logo__large.png";